
export { useWalletQuery } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/wallet/data-access/index.ts"